import { Theme } from "@mui/material";

export const Variants = (theme: Theme) => {
  return {
    primary: {
      color: theme.colors["neutral.950"],
      transition: "all 300ms ease-in-out",
      backgroundSize: "200% auto",

      "&:not(:disabled):hover": {
        backgroundPosition: "right center"
      },

      "&:disabled": {
        color: theme.colors["neutral.950"],
      },
    },
    secondary: {
      color: theme.colors["neutral.50"],
      backgroundColor: theme.colors["neutral.900"],

      "&:not(:disabled):hover": {
        backgroundColor: theme.colors["neutral.800"],
      },

      "&:disabled": {
        "&:hover": {
          backgroundColor: theme.colors["neutral.900"],
        },
      },
    },
    secondaryLight: {
      color: theme.colors["neutral.50"],
      backgroundColor: theme.colors["neutral.800"],

      "&:not(:disabled):hover": {
        backgroundColor: theme.colors["neutral.700"],
      },

      "&:disabled": {
        "&:hover": {
          backgroundColor: theme.colors["neutral.800"],
        },
      },
    },
    secondaryGray: {
      color: theme.colors["neutral.50"],
      backgroundColor: theme.colors["neutral.900"],

      "&:not(:disabled):hover": {
        backgroundColor: theme.colors["neutral.800"],
      },

      "&:disabled": {
        "&:hover": {
          backgroundColor: theme.colors["neutral.950"],
        },
      },
    },
    secondaryDark: {
      color: theme.colors["neutral.50"],
      backgroundColor: theme.colors["neutral.950"],

      "&:not(:disabled):hover": {
        backgroundColor: theme.colors["neutral.800"],
      },

      "&:disabled": {
        "&:hover": {
          backgroundColor: theme.colors["neutral.950"],
        },
      },
    },
    tertiary: {
      paddingLeft: 0,
      paddingRight: 0,

      color: theme.colors["neutral.50"],
      backgroundColor: "transparent",

      "&:not(:disabled):hover, &:hover": {
        color: theme.colors["neutral.400"],
        backgroundColor: "transparent",
      },

      "&:disabled": {
        color: theme.colors["neutral.50"],
      },
    },
    success: {
      color: theme.colors["neutral.50"],
      backgroundColor: theme.colors["green.600"],

      "&:not(:disabled):hover": {
        backgroundColor: theme.colors["green.700"],
      },

      "&:disabled": {
        "&:hover": {
          backgroundColor: theme.colors["green.600"],
        },
      },
    },
    destructive: {
      color: theme.colors["neutral.50"],
      backgroundColor: theme.colors["red.700"],

      "&:not(:disabled):hover": {
        backgroundColor: theme.colors["red.800"],
      },

      "&:disabled": {
        "&:hover": {
          backgroundColor: theme.colors["red.700"],
        },
      },
    },
    destructiveDark: {
      color: theme.colors["neutral.950"],
      backgroundColor: theme.colors["red.500"],
      fontWeight: theme.fontWeights.semibold,
      size: theme.fontSizes.md,

      "&:not(:disabled):hover": {
        backgroundColor: theme.colors["red.800"],
      },

      "&:disabled": {
        "&:hover": {
          backgroundColor: theme.colors["red.700"],
        },
      },
    },
    ghost: {
      paddingLeft: 0,
      paddingRight: 0,

      color: theme.colors["neutral.500"],
      backgroundColor: "transparent",

      "&:not(:disabled):hover, &:hover": {
        color: theme.colors["neutral.300"],
        backgroundColor: "transparent",
      },

      "&:disabled": {
        color: theme.colors["neutral.700"],
      },
    },
    linkButtonDisabled: {
      color: `${theme.colors["neutral.700"]} !important`,
      backgroundColor: theme.colors["neutral.900"],
      border: `1px solid ${theme.colors["neutral.700"]}`
    }
  }
}

export const SizeStyles = (theme: Theme) => {
  return {
    xs: {
      fontSize: theme.fontSizes.xs,
      padding: `${theme.space._200} ${theme.space._300}`,
    },
    sm: {
      fontSize: theme.fontSizes.sm,
      padding: `${theme.space._300} ${theme.space._400}`,
    },
    md: {
      fontSize: theme.fontSizes.md,
      padding: `${theme.space._400} ${theme.space._500}`,
    },
    lg: {
      fontSize: theme.fontSizes.lg,
      padding: `${theme.space._500} ${theme.space._600}`,
    },
  };
};

export const GradientStyles = (theme: Theme) => {
  return {
    gradient1: {
      backgroundImage: theme.utils.linearGradient("horizontal", "blueToGreen"),
    },
    gradient2: {
      backgroundImage: theme.utils.linearGradient("horizontal", "pinkToPurple"),
    },
    gradient3: {
      backgroundImage: theme.utils.linearGradient("horizontal", "amberToRed"),
    },
    gradient4: {
      backgroundImage: theme.utils.linearGradient("vertical", "amberToGreen"),
      backgroundSize: "auto 200%",

      "&:not(:disabled):hover": {
        backgroundPosition: "center bottom"
      },
    },
  };
};